import * as React from "react";

import { SxProps } from "@mui/material";
import Grid, { GridProps } from "@mui/material/Grid";

import { mergeSx } from "@/helpers/mergeSx";

interface DisplayGridProps extends GridProps {
  when: boolean;
}

export const DisplayGrid: React.FunctionComponent<React.PropsWithChildren<DisplayGridProps>> = ({
  when,
  children,
  className: propsClassName,
  sx: propsSx,
  ...props
}) => {
  const visibilitySx: SxProps = when
    ? { maxWidth: "100%", position: "relative", height: "auto" }
    : { display: "none", position: "absolute", height: 0 };

  const mergedSx = mergeSx(visibilitySx, propsSx);

  return (
    <Grid {...props} className={propsClassName} sx={mergedSx}>
      {children}
    </Grid>
  );
};
